export default __webpack_public_path__ + "static/media/MelGroundFloor_bkup.fc498fc1.jpg";